import {useState, useEffect} from "react";
import TimerUtil from "../../../../../utils/timer";

export default ({timestamp}) => {
    const [time, setTime] = useState(10267489),
          timer = TimerUtil.parse(time, true);

    useEffect(() => {
        if(time > 0) {
            window.facebookTaskTimerTimeout = setTimeout(() => {
                setTime(parseInt(timestamp) - Date.now())
            }, 500);
        }

        return () => clearTimeout(window.facebookTaskTimerTimeout);
    }, [time]);

    if(time < 0)
        return (
            <div className="button-block pending">
                RELOAD
            </div>
        )

    return (
        <div className="button-block pending">
            {timer.hours}:{timer.minutes}:{timer.seconds}
        </div>
    )
}